import React from "react";

import { useTranslation } from "react-i18next";
import { isObject } from "../../../../helpers/helpers";
import "./index.scss";

const AddToAccount = (props) => {
  const { t } = useTranslation();
  const itemsLength = isObject(props.selectedRowsIds)
    ? Object.keys(props.selectedRowsIds).length
    : props.selectedRowsIds.length;

  const btnClass =
    itemsLength > 0 ? "btn btn-primary btn-add-to-account" : "btn btn-primary btn-add-to-account disabled";

  const handleOnSubmit = () => {
    const active = itemsLength > 0;
    if (active) {
      props.onSubmit();
    }
  };

  return (
    <div data-testid="AddToAccount" className="add-to-account">
      <div className="mt-5">
        <div className="add-contracts-container d-flex justify-content-between">
          <div className="d-flex inner-container ">
            <p data-testid="ParagraphAddToAccount">
              {t("common.haveSelected")} {props.selectedRowsIds && itemsLength}{" "}
              {itemsLength === 1 ? t("common.contract") : t("common.associate.contracts")}
            </p>
          </div>

          <button
            type="button"
            data-testid="ButtonAddToAccount"
            onClick={handleOnSubmit}
            className={btnClass}
          >
            {props.isDisabledPage
              ? t("contract.dissociate.cta.remove")
              : t("common.addToUser")}
            <i className="gc-icon-functional-arrow-right" aria-hidden="true"/>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddToAccount;
